// extracted by mini-css-extract-plugin
export default {"navButton":"NavButton_navButton__L1Z6o","desktop":"NavButton_desktop__smC2H","active":"NavButton_active__0hqTE","mobile":"NavButton_mobile__4U8bt","label":"NavButton_label__uKl+-"};